// extracted by mini-css-extract-plugin
export var buttonContainer = "_9m-1";
export var fontSizeSelect = "_9m-3";
export var formatSelect = "_9m-2";
export var formats = "_9m-4";
export var hidden = "_9m-5";
export var icon = "_9m-6";
export var select = "_9m-0";